export enum GraphSeries {
  customerChatContacts = 'customerChatContacts',
  linkContacts = 'linkContacts',
  checkboxContacts = 'checkboxContacts',
  sendToMessengerContacts = 'sendToMessengerContacts',
  commentGuardContacts = 'commentGuardContacts',
  commentsCount = 'commentsCount',
}

type DataSetConfig = {
  baseColor: string;
  label: string;
  borderColor: string;
  pointBackgroundColor: string;
  lineTension: number;
  borderWidth: number;
};

export const MainConfig = {
  responsive: true,
  maintainAspectRatio: true,
  aspectRatio: 6,
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
        },
      },
    ],
  },
};

export const DataSetsConfig: { [key: string]: DataSetConfig } = {
  [GraphSeries.customerChatContacts]: {
    label: 'Customer Chat Widget Leads',
    baseColor: 'rgba(93, 95, 216, 0.3)',
    borderColor: '#3555F0',
    pointBackgroundColor: '#3555F0',
    borderWidth: 2,
    lineTension: 0.1,
  },
  [GraphSeries.linkContacts]: {
    label: 'Share Link Leads',
    baseColor: 'rgba(97, 181, 57, 0.3)',
    borderColor: '#61B539',
    pointBackgroundColor: '#61B539',
    lineTension: 0.1,
    borderWidth: 2,
  },
  [GraphSeries.checkboxContacts]: {
    label: 'Checkbox Plugin Leads',
    baseColor: 'rgba(237, 179, 77, 0.3)',
    borderColor: '#EDB34D',
    pointBackgroundColor: '#EDB34D',
    lineTension: 0.1,
    borderWidth: 2,
  },
  [GraphSeries.sendToMessengerContacts]: {
    label: 'Send to Messenger Button Leads',
    baseColor: 'rgba(255, 133, 118, 0.3)',
    borderColor: '#E94D7B',
    pointBackgroundColor: '#E94D7B',
    lineTension: 0.1,
    borderWidth: 2,
  },
  [GraphSeries.commentGuardContacts]: {
    label: 'Leads',
    baseColor: 'rgba(93, 95, 216, 0.3)',
    borderColor: '#3555F0',
    pointBackgroundColor: '#3555F0',
    borderWidth: 2,
    lineTension: 0.1,
  },
  [GraphSeries.commentsCount]: {
    label: 'Comments',
    baseColor: 'rgba(255, 133, 118, 0.3)',
    borderColor: '#E94D7B',
    pointBackgroundColor: '#E94D7B',
    lineTension: 0.1,
    borderWidth: 2,
  },
};
